module.exports = __webpack_public_path__ + "media/KikiHM.7f935326.mp3";